module.exports = __webpack_public_path__ + "static/media/7.5e3f7c83.JPG";